import React from 'react'
import UsersForm from './UsersForm'

const NewUserPage = () => {
  return (
    <>
     <UsersForm formType='create' currentUserId={null} ></UsersForm>
    </>
  )
}

export default NewUserPage
